import script from "./TextCardsForm.vue?vue&type=script&setup=true&lang=js"
export * from "./TextCardsForm.vue?vue&type=script&setup=true&lang=js"

import "./TextCardsForm.vue?vue&type=style&index=0&id=3f434da2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f434da2"]])

export default __exports__